// Punto de entrada principal de la aplicación React
// Este archivo monta el componente App en el elemento #root del HTML

import ReactDOM from 'react-dom/client'
// Importar el componente principal de la aplicación
import App from './App.jsx'
// Importar estilos globales (variables CSS, reset, etc.)
import './index.css'

// Configuración dinámica desde variables de entorno
const sanitizeEnvValue = (value) => typeof value === 'string' ? value.trim().replace(/^['"]|['"]$/g, '').trim() : value
const normalizeAssetPath = (value, fallback) => {
  const cleaned = sanitizeEnvValue(value)
  if (!cleaned) return fallback
  if (/^https?:\/\//i.test(cleaned)) return cleaned
  let path = cleaned.replace(/\\/g, '/')
  if (path.startsWith('/public/')) path = path.replace(/^\/public\//, '/')
  if (path.startsWith('public/')) path = path.replace(/^public\//, '')
  if (!path.startsWith('/')) path = `/${path}`
  return path
}
const systemName = sanitizeEnvValue(import.meta.env.VITE_SYSTEM_NAME) || 'PinoHome'
const faviconPath = normalizeAssetPath(import.meta.env.VITE_SYSTEM_FAVICON_PATH, '/pinohome/favicon.png')

document.title = systemName

const buildFaviconUrl = (path) => {
  try {
    const url = new URL(path, window.location.origin)
    url.searchParams.set('v', encodeURIComponent(path))
    return url.toString()
  } catch (_error) {
    return path
  }
}

const updateFavicon = (path) => {
  const links = document.querySelectorAll("link[rel*='icon']");
  links.forEach(link => link.href = path);
  
  // Si no existen, crearlos (aunque index.html ya los tiene)
  if (links.length === 0) {
    const link = document.createElement('link');
    link.type = 'image/png';
    link.rel = 'icon';
    link.href = path;
    document.head.appendChild(link);
  }
};

updateFavicon(buildFaviconUrl(faviconPath));

// Obtener el elemento raíz del DOM donde se montará React
// El elemento #root está definido en index.html
ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)

